export default __webpack_public_path__ + "static/media/cvv_info2.3a7674af.jpg";